import { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { LIST_WONDER_LINES } from '../../graphql/queries/oneSongWonder/onesongwonder';

const useListWonderLines = () => {
  const [value, setValue] = useState('');
  const [loadWonderLines, { loading, data }] = useLazyQuery(LIST_WONDER_LINES, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    async function fetchData() {
      if (value) {
        await loadWonderLines({
          variables: {
            filter: {
              filtered: [{ type: 'Values (PSHE, SMSC)', formatted_name: value }],
            },
          },
        });
      } else {
        await loadWonderLines();
      }
    }
    fetchData();
  }, [value, loadWonderLines]);

  return { loading, data, setValue, value };
};

export default useListWonderLines;
